import { useIdle, useTimestamp, useDocumentVisibility } from '@vueuse/core'
import { computed } from 'vue'

export function useInactivityMonitor() {
  const { lastActive } = useIdle(5000)
  const now = useTimestamp({ interval: 1000 })
  const visibility = useDocumentVisibility()
  const userStore = useUserStore()

  const idledFor = computed(() => {
    // Don't track inactivity if user is not authenticated or currently logging out
    if (!userStore.isAuthenticated || userStore.loggingOut) return 0

    // Don't accumulate idle time while the tab is hidden.
    // Background tabs have throttled timers, so idledFor could jump
    // from 0 to 1800+ in one tick when the tab returns to the foreground.
    // By returning 0 while hidden, we let the user's first interaction
    // upon return reset lastActive before the idle check runs.
    if (visibility.value === 'hidden') return 0

    return Math.floor((now.value - lastActive.value) / 1000)
  })

  const isTabVisible = computed(() => visibility.value === 'visible')

  return {
    idledFor,
    isTabVisible
  }
}
